<!--
  - Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
  - Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
  - Written by Dominik Lippl <dl@venus.bayern>
  -->

<template>
  <div>
    {{ label }}

    <span v-if="postfix" class="text-gray-400 text-sm font-normal" :class="`${postfixColor ? postfixColor : 'text-gray-400' }`">{{ postfix }}</span>
  </div>
</template>

<script>
export default {
  name: "LabelComponent",
  props: {
    label: {
      required: true
    },
    postfix: {
      required: false
    },
    postfixColor: {
      required: false
    }
  }
};
</script>

<style scoped>

</style>